//import axios from 'axios'
import TokenService from './token.service'
import api from './api'
class AuthService {
  prefix = 'admin/auth'
  async login(user) {
    return await api
      .post(this.prefix + '/login', {
        email: user.email,
        password: user.password,
      })
      .then(async (response) => {
        const result = response.data
        const user = result.user
        TokenService.setUser({
          accessToken: result.access_token,
          refreshToken: result.refresh_token,
          id: user.id,
          phone: user.phone,
          picture: user.picture,
          role: user.role,
          status: user.status,
          name: user.display_name,
        })
      })
  }

  logout() {
    TokenService.removeUser()
  }
}

export default new AuthService()
